import { CustomComponentTypes } from '@models/Forms/CustomComponentTypes';

export type CustomComponentPreviewBlocker =
    'missing-session-data-source' | 'live-renderer-not-implemented' | 'unknown-component-type';

export interface ICustomComponentPreviewDescriptor {
    displayName: string;
    blocker: CustomComponentPreviewBlocker;
    reason: string;
    blockedServices: readonly string[];
}

export const customComponentPreviewRegistry = {
    [CustomComponentTypes.Unknown]: {
        displayName: 'Неизвестный компонент',
        blocker: 'unknown-component-type',
        reason: 'Для типа компонента не зарегистрирован безопасный renderer.',
        blockedServices: [],
    },
    [CustomComponentTypes.WinnerSelectionTableDemand]: {
        displayName: 'Выбор победителя по закупке',
        blocker: 'missing-session-data-source',
        reason: 'Данные и действия выбора победителя ещё не переведены на document-scoped preview session.',
        blockedServices: ['WinnerSelectionService'],
    },
    [CustomComponentTypes.WinnerSelectionTableLot]: {
        displayName: 'Выбор победителя по лотам',
        blocker: 'live-renderer-not-implemented',
        reason: 'Для этого типа отсутствует полноценный renderer и в обычной карточке.',
        blockedServices: [],
    },
    [CustomComponentTypes.WinnerSelectionTablePositions]: {
        displayName: 'Выбор победителя по позициям',
        blocker: 'missing-session-data-source',
        reason: 'Позиции, предложения и действия ещё не переведены на document-scoped preview session.',
        blockedServices: ['WinnerSelectionService'],
    },
    [CustomComponentTypes.WinnerSelectionTableMixed]: {
        displayName: 'Смешанный выбор победителя',
        blocker: 'live-renderer-not-implemented',
        reason: 'Для этого типа отсутствует полноценный renderer и в обычной карточке.',
        blockedServices: [],
    },
    [CustomComponentTypes.WinnerSelectionTableKO]: {
        displayName: 'Квалификационный отбор победителя',
        blocker: 'missing-session-data-source',
        reason: 'Данные квалификационного отбора и action-формы ещё не переведены на preview session.',
        blockedServices: ['WinnerSelectionService'],
    },
    [CustomComponentTypes.SupplyScheduleTable]: {
        displayName: 'График поставок',
        blocker: 'missing-session-data-source',
        reason: 'Данные графика поставок ещё не переведены на document-scoped preview session.',
        blockedServices: ['SupplyScheduleService'],
    },
    [CustomComponentTypes.WinnerSelection2]: {
        displayName: 'Выбор победителя: матрица позиций и заявок',
        blocker: 'missing-session-data-source',
        reason: 'Матрица читает и сохраняет решения живых предложений; document-scoped preview session для неё не реализована.',
        blockedServices: ['WinnerSelection2Service'],
    },
} satisfies Record<CustomComponentTypes, ICustomComponentPreviewDescriptor>;

const unknownPreviewDescriptor: ICustomComponentPreviewDescriptor = {
    displayName: 'Неизвестный компонент',
    blocker: 'unknown-component-type',
    reason: 'Тип отсутствует в реестре support preview; его renderer и источники данных заблокированы.',
    blockedServices: [],
};

export const getCustomComponentPreviewDescriptor = (type: CustomComponentTypes): ICustomComponentPreviewDescriptor =>
    (customComponentPreviewRegistry as Partial<Record<number, ICustomComponentPreviewDescriptor>>)[type] ??
    unknownPreviewDescriptor;
